var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25V2.25H21V5.25L14.25 12.75V20.25L9.75 21.75V12.75L3 5.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 2.25C2.25 2.05109 2.32902 1.86032 2.46967 1.71967C2.61032 1.57902 2.80109 1.5 3 1.5H21C21.1989 1.5 21.3897 1.57902 21.5303 1.71967C21.671 1.86032 21.75 2.05109 21.75 2.25V5.25C21.75 5.43496 21.6816 5.61339 21.558 5.751L15 13.038V20.25C14.9999 20.4073 14.9503 20.5607 14.8582 20.6883C14.7661 20.8159 14.6363 20.9113 14.487 20.961L9.987 22.461C9.87431 22.4985 9.75432 22.5088 9.6369 22.4909C9.51948 22.4729 9.408 22.4274 9.31162 22.358C9.21525 22.2886 9.13674 22.1972 9.08257 22.0915C9.02839 21.9858 9.00009 21.8688 9 21.75V13.038L2.442 5.751C2.31841 5.61339 2.25003 5.43496 2.25 5.25V2.25ZM3.75 3V4.962L10.308 12.249C10.4316 12.3866 10.5 12.565 10.5 12.75V20.709L13.5 19.71V12.75C13.5 12.565 13.5684 12.3866 13.692 12.249L20.25 4.962V3H3.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.7a096ccc.svg";
export { ForwardRef as ReactComponent };